import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	employee: null,
	linkUser: [],
	error: "",
	loading: false,
};

// ADD_DESIGNATION
export const addLinkUser = createAsyncThunk(
	"linkUser/addLinkUser",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `linkUser/`,
				data: {
					...values,
				},
			});
			toast.success("linkUser Added");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding linkUser try again");
			// console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

export const addLinkCompany = createAsyncThunk(
	"linkUser/addLinkUser",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `linkUser/linkCompany`,
				data: {
					...values,
				},
			});
			toast.success("linkUser Added");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding linkUser try again");
			// console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

export const updateLinkUser = createAsyncThunk(
	"linkUser/updateLinkUser",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "put",
				url: `linkUser/${id}`,
				data: {
					...values,
				},
			});
			toast.success("Link User Information Updated Successfully");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			// console.log(error.message);
			toast.error("Error in updating link User information");
			return {
				message: "error",
			};
		}
	}
);


// DELETE_DESIGNATION
export const deleteLinkUser = createAsyncThunk(
	"linkUser/deleteLinkUser",
	async (id) => {
		try {
			const resp = await axios({
				method: "patch",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `linkUser/${id}`,
				data: {
					status: false,
				},
			});

			return resp.data.id;
		} catch (error) {
			// console.log(error.message);
		}
	}
);

// DESIGNATION_DETAILS
export const loadSingleLinkUser = createAsyncThunk(
	"linkUser/loadSingleLinkUser",
	async (id) => {
		try {
			const data = await axios.get(`linkUser/employee/${id}`);
			return data;
		} catch (error) {
			// console.log(error.message);
		}
	}
);

// DESIGNATIONS
export const loadAllLinkUser = createAsyncThunk(
	"linkUser/loadAllLinkUser",
	async (id) => {
		try {
			const { data } = await axios.get(`linkUser/user/${id}`);
			return data;
		} catch (error) {
			// console.log(error.message);
		}
	}
);

export const loadAllUserRequest = createAsyncThunk(
	"linkUser/loadAllUserRequest",
	async (id) => {
		try {
			const { data } = await axios.get(`linkUser/company/${id}`);
			return data;
		} catch (error) {
			// console.log(error.message);
		}
	}
);

export const loadAllIndivisualUser = createAsyncThunk(
	"linkUser/loadAllIndivisualUser",
	async () => {
		try {
			const { data } = await axios.get(`user/getAllIndivisualUser`);
			// console.log("data ...", data)
			return data;
		} catch (error) {
			// console.log(error.message);
		}
	}
);

export const loadAllCompanies = createAsyncThunk(
	"linkUser/loadAllCompanies",
	async () => {
		try {
			const { data } = await axios.get(`user/getAllCompany`);
			// console.log("data ...", data)
			return data;
		} catch (error) {
			// console.log(error.message);
		}
	}
);


export const loadAllLinkUserByEmployee = createAsyncThunk(
	"linkUser/loadAllLinkUserByEmployee",
	async () => {
		try {
			const { data } = await axios.get(`linkUser/employee`);

			return data;
		} catch (error) {
			// console.log(error.message);
		}
	}
);

const linkUserSlice = createSlice({
	name: "linkUser",
	initialState,
	reducers: {
		clearLinkUser: (state) => {
			state.linkUser = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for loadAllLinkUser ======

		builder.addCase(loadAllLinkUser.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(loadAllLinkUser.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(loadAllLinkUser.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 1) ====== builders for loadAllIndivisualUser ======

		builder.addCase(loadAllIndivisualUser.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(loadAllIndivisualUser.fulfilled, (state, action) => {
			state.loading = false;
			state.linkUser = action.payload;
		});

		builder.addCase(loadAllIndivisualUser.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
		

		// 2) ====== builders for loadAllUserRequest ======

		builder.addCase(loadAllUserRequest.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(loadAllUserRequest.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(loadAllUserRequest.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 3) ====== builders for loadAllCompanies ======

		builder.addCase(loadAllCompanies.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(loadAllCompanies.fulfilled, (state, action) => {
			state.loading = false;
			state.linkCompany = action.payload;
		});

		builder.addCase(loadAllCompanies.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for updateLinkUser ======

		builder.addCase(updateLinkUser.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateLinkUser.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updateLinkUser.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
		// 2) ====== builders for loadAllLinkUserByEmployee ======

		builder.addCase(loadAllLinkUserByEmployee.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(loadAllLinkUserByEmployee.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(loadAllLinkUserByEmployee.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for addLinkUser ======

		builder.addCase(addLinkUser.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addLinkUser.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addLinkUser.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 3) ====== builders for loadSingleLinkUser ======

		builder.addCase(loadSingleLinkUser.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(loadSingleLinkUser.fulfilled, (state, action) => {
			state.loading = false;
			state.linkUser = action.payload.data;
		});

		builder.addCase(loadSingleLinkUser.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for deleteLinkUser ======

		builder.addCase(deleteLinkUser.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deleteLinkUser.fulfilled, (state, action) => {
			state.loading = false;
			const filterCategory = state.list.filter(
				(category) => category.id !== parseInt(action.payload) && category
			);
			state.list = filterCategory;

			const filterLinkUser = state.list.filter(
				(desig) => desig.id !== parseInt(action.payload) && desig
			);

			state.list = filterLinkUser;
		});

		builder.addCase(deleteLinkUser.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
	},
});

export default linkUserSlice.reducer;
export const { clearLinkUser } = linkUserSlice.actions;
